(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["shipping-calculator-cart"] && !Shopify.designMode) return;
  try {
    (function() {
    "use strict";
    var root = document.querySelector("[data-cart-calculator]");
    if (!root) return;

    /**
     * ONC-155: mesma correcao da calculadora da PDP. Sem consulta externa de
     * CEP — a Shopify exige o campo estado preenchido mas ignora o valor
     * (quem calcula e o CEP, na transportadora), entao enviamos um estado
     * fixo e o calculo nao depende mais de um terceiro estar no ar.
     */
    var ESTADO_PADRAO = "Sao Paulo";

    var shippingZip = document.getElementById("frete-cep-cart");
      var shippingCountry = document.getElementById("pais-simulator-cart");
      var shippingProvince = document.getElementById("estados-simulator-cart");
      var shippingMessage = document.getElementById("frete-error-cart");
      var freteLista = document.getElementById("frete-results-cart");
      var calcularBtn = document.getElementById("frete-calcular-cart");
      if (!shippingZip || !calcularBtn) return;

      var config = {
      errorMessage: root.dataset.errorMessage || "CEP não encontrado, verifique o número digitado.",
      unavailableMessage: root.dataset.unavailableMessage || "Não conseguimos calcular o frete agora, tente novamente.",
      freeShippingText: root.dataset.freeShippingText || "Grátis"
    };

    function formatMoney(cents, format) {
      if (typeof window.MinimogSettings !== "undefined" && window.MinimogSettings.money_format) {
        format = window.MinimogSettings.money_format;
      }
      if (!format) format = "R$ {{amount}}";
      var value = (cents / 100).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, "$1,");
      return format.replace("{{amount}}", value).replace("{{amount_no_decimals}}", Math.round(cents / 100)).replace("{{amount_with_comma_separator}}", value);
    }

    shippingZip.addEventListener("input", function(e) {
      var value = e.target.value.replace(/\D/g, "");
      if (value.length > 8) value = value.slice(0, 8);
      if (value.length > 5) value = value.slice(0, 2) + "." + value.slice(2, 5) + "-" + value.slice(5);
      else if (value.length > 2) value = value.slice(0, 2) + "." + value.slice(2);
      e.target.value = value;
    });

    function isDateBeforeToday(date) {
      return new Date(date.toDateString()) < new Date(new Date().toDateString());
    }
    function excludeDate(name) {
      return name !== "Entrega Expressa - pedidos feitos até 11h chegam em até 24hrs úteis" && name !== "Entrega Rápida - pedidos chegam em até 48hrs úteis";
    }

    calcularBtn.addEventListener("click", function(e) {
      e.preventDefault();
      var cepLimpo = shippingZip.value.replace(/\D/g, "");
      if (cepLimpo.length < 8) {
        shippingMessage.textContent = config.errorMessage;
        shippingMessage.style.display = "block";
        return;
      }
      shippingMessage.textContent = "";
      shippingMessage.style.display = "none";

      shippingProvince.value = ESTADO_PADRAO;
      getRatesCart();
    });

    function getRatesCart() {
      shippingMessage.style.display = "none";
      freteLista.style.display = "block";
      freteLista.innerHTML = '<div style="display:flex;justify-content:center;padding:20px;"><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style="animation:spin 1s linear infinite"><style>@keyframes spin{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}</style><circle cx="12" cy="12" r="10" stroke="#d9d9d9" stroke-width="3" fill="none"/><path d="M12 2a10 10 0 0 1 10 10" stroke="#414141" stroke-width="3" fill="none" stroke-linecap="round"/></svg></div>';

      var params = new URLSearchParams({
        "shipping_address[country]": shippingCountry.value,
        "shipping_address[province]": shippingProvince.value,
        "shipping_address[zip]": shippingZip.value.replace(/\D/g, "")
      });

      // ONC-155: a cotacao e assincrona; enquanto a transportadora nao
      // responde, a Shopify devolve a lista vazia. Espera ficar pronta.
      function consultarFreteCart(tentativa) {
        return fetch("/cart/shipping_rates.json?_easygift_internal=true&" + params.toString(), {
          credentials: "same-origin",
          headers: { "Content-Type": "application/json" }
        }).then(function(r) { return r.json(); }).then(function(d) {
          var pronto = d && d.shipping_rates && d.shipping_rates.length;
          if (pronto || tentativa >= 4) return d;
          return new Promise(function(res) { setTimeout(res, 1000 * tentativa); })
            .then(function() { return consultarFreteCart(tentativa + 1); });
        });
      }

      consultarFreteCart(1)
        .then(function(d) {
          if (d.shipping_rates && d.shipping_rates.length) {
            freteLista.innerHTML = "";
            for (var i = 0; i < d.shipping_rates.length; i++) {
              var deliveryDate = d.shipping_rates[i].delivery_date;
              var entrega = deliveryDate ? new Date(d.shipping_rates[i].delivery_date) : null;
              var checkBeforeday = entrega ? isDateBeforeToday(entrega) : true;
              var excludeDateCheck = excludeDate(d.shipping_rates[i].name);
              var dataFormatada = entrega ? entrega.getDate() + "/" + (entrega.getMonth() + 1) + "/" + entrega.getFullYear() : "";
              var valorFrete = d.shipping_rates[i].price;
              if (valorFrete === "0.00" || valorFrete == null) valorFrete = config.freeShippingText;
              else valorFrete = formatMoney(parseFloat(valorFrete) * 100, null);
              var entregaText = "";
              if (deliveryDate == null && excludeDateCheck || (entrega && checkBeforeday && excludeDateCheck)) entregaText = "Estimativa de entrega indisponível";
              else if (!excludeDateCheck) entregaText = "";
              else entregaText = "(Estimativa de entrega: " + dataFormatada + ")";
              var freteItem = document.createElement("div");
              freteItem.className = "frete-item";
              freteItem.innerHTML = '<div class="frete-item__info"><p class="frete-item__name">' + d.shipping_rates[i].name + "</p>" + (entregaText ? '<span class="frete-item__delivery">' + entregaText + "</span>" : "") + "</div><div class=\"frete-item__price\">" + valorFrete + "</div>";
              freteLista.appendChild(freteItem);
            }
          } else {
            freteLista.innerHTML = "";
            freteLista.style.display = "none";
            shippingMessage.textContent = config.unavailableMessage;
            shippingMessage.style.display = "block";
          }
        })
        .catch(function(err) {
          console.error("[frete carrinho] falha ao calcular:", err);
          freteLista.innerHTML = "";
          freteLista.style.display = "none";
          shippingMessage.textContent = config.unavailableMessage;
          shippingMessage.style.display = "block";
        });
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["shipping-calculator"] && !Shopify.designMode) return;
  try {
    (function () {
    "use strict";

    var freteCalculo = document.querySelector('.frete-calculo');
    if (!freteCalculo) return;

    /**
     * ONC-155: sem dependencia de servico externo de CEP.
     * A Shopify EXIGE o campo estado preenchido na consulta de frete, mas o
     * valor nao afeta o resultado — quem calcula e o CEP, na transportadora.
     * Comprovado: CEP de SC declarado como "Sao Paulo" devolve exatamente os
     * mesmos precos (10.04/15.62/20.19), e CEP do Acre como "Sao Paulo" idem
     * (50.18/64.51/110.75). Por isso enviamos um estado fixo e o calculo
     * deixa de quebrar quando o servico de CEP esta fora ou bloqueado no
     * navegador do cliente, que era a causa do chamado.
     */
    var ESTADO_PADRAO = 'Sao Paulo';

    /**
     * ONC-155: a etapa que falhou fica registrada no console (E1 ler carrinho,
     * E2 limpar, E3 adicionar produto, E4 consultar frete, E5 sem cotacao),
     * mas NAO aparece para a cliente — a mensagem na tela e so o texto limpo.
     * Para investigar de novo, basta acrescentar o codigo ao innerHTML abaixo.
     */
    function mostrarFalha(codigo, detalhe) {
      console.error('[frete ' + codigo + ']', detalhe || '');
      freteLista.innerHTML = "";
      freteLista.style.display = "none";
      shippingMessage.innerHTML = config.unavailableMessage;
      shippingMessage.style.display = "block";
    }

    var shippingZip = document.getElementById('frete-cep');
    var shippingCountry = document.getElementById('pais-simulator');
    var shippingProvince = document.getElementById('estados-simulator');
    var shippingMessage = document.getElementById('frete-error');
    var freteLista = document.getElementById('frete-results');
    var calcularBtn = document.getElementById('frete-calcular');

    if (!shippingZip || !calcularBtn) return;

    // Configurações dos data attributes
    var config = {
      errorMessage: freteCalculo.dataset.errorMessage || 'CEP não encontrado, verifique o número digitado.',
      unavailableMessage: freteCalculo.dataset.unavailableMessage || 'Não conseguimos calcular o frete agora, tente novamente.',
      freeShippingText: freteCalculo.dataset.freeShippingText || 'Grátis'
    };

    // Seletor do produto
    var productSelect = document.getElementById('ProductSelect-product-template');
    if (!productSelect) productSelect = document.getElementsByName('id')[0];
    if (!productSelect) return;

    // Máscara de CEP (formato: 00.000-000)
    shippingZip.addEventListener('input', function(e) {
      var value = e.target.value.replace(/\D/g, '');
      if (value.length > 8) value = value.slice(0, 8);
      if (value.length > 5) {
        value = value.slice(0, 2) + '.' + value.slice(2, 5) + '-' + value.slice(5);
      } else if (value.length > 2) {
        value = value.slice(0, 2) + '.' + value.slice(2);
      }
      e.target.value = value;
    });

    // Click no botão calcular
    calcularBtn.addEventListener('click', function(e) {
      e.preventDefault();

      var cepLimpo = shippingZip.value.replace(/\D/g, '');
      if (cepLimpo.length < 8) {
        shippingMessage.innerHTML = config.errorMessage;
        shippingMessage.style.display = 'block';
        freteLista.innerHTML = "";
        freteLista.style.display = "none";
        return;
      }

      shippingMessage.innerHTML = '';
      shippingMessage.style.display = 'none';

      // Estado fixo: obrigatorio para a Shopify, irrelevante para o calculo.
      shippingProvince.value = ESTADO_PADRAO;

      var variantId = productSelect.value;
      if (!variantId) {
        var firstOption = productSelect.querySelector('option');
        if (firstOption) variantId = firstOption.value;
      }

      getRates(parseInt(variantId));
    });

    function getRates(variantId) {
      if (typeof variantId === 'undefined') return;

      // Busca o input de quantidade da página do produto atual
      var productQuantity = document.querySelector('.m-main-product .m-quantity__input');
      var quantity = (productQuantity && productQuantity.value) ? parseInt(productQuantity.value) : 1;
      
      var addData = {
        'id': variantId,
        'quantity': quantity
      };

      var originalCartItems = [];

      function isDateBeforeToday(date) {
        return new Date(date.toDateString()) < new Date(new Date().toDateString());
      }

      function excludeDate(name) {
        return (name != 'Entrega Expressa - pedidos feitos até 11h chegam em até 24hrs úteis' && name != 'Entrega Rápida - pedidos chegam em até 48hrs úteis');
      }

      function restoreCart() {
        if (originalCartItems.length === 0) return Promise.resolve();
        
        return fetch('/cart/clear.js', {
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          method: 'POST'
        }).then(function() {
          var itemsToAdd = originalCartItems.map(function(item) {
            return {
              id: item.variant_id,
              quantity: item.quantity,
              properties: item.properties
            };
          });
          
          return fetch('/cart/add.js', {
            body: JSON.stringify({ items: itemsToAdd }),
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' },
            method: 'POST'
          });
        });
      }

      // Mostra loading
      shippingMessage.style.display = "none";
      freteLista.style.display = "block";
      freteLista.innerHTML = '<div style="display: flex; justify-content: center; padding: 20px;"><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style="animation: spin 1s linear infinite;"><style>@keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }</style><circle cx="12" cy="12" r="10" stroke="#d9d9d9" stroke-width="3" fill="none"/><path d="M12 2a10 10 0 0 1 10 10" stroke="#414141" stroke-width="3" fill="none" stroke-linecap="round"/></svg></div>';

      var etapaAtual = 'E1';

      // 1. Busca os itens do carrinho atual
      fetch('/cart.js', {
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' }
      })
      .then(function(response) {
        if (!response.ok) throw new Error('cart.js HTTP ' + response.status);
        return response.json();
      })
      .then(function(cart) {
        originalCartItems = cart.items || [];
        etapaAtual = 'E2';

        // 2. Limpa o carrinho
        return fetch('/cart/clear.js', {
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          method: 'POST'
        });
      })
      .then(function(response) {
        if (response && !response.ok) throw new Error('clear HTTP ' + response.status);
        etapaAtual = 'E3';
        // 3. Adiciona apenas o produto para cálculo
        return fetch('/cart/add.js', {
          body: JSON.stringify(addData),
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          method: 'POST'
        });
      })
      .then(function(response) {
        if (!response.ok) throw new Error('add HTTP ' + response.status);
        return response.json();
      })
      .then(function() {
        etapaAtual = 'E4';
        var params = new URLSearchParams({
          'shipping_address[country]': shippingCountry.value,
          'shipping_address[province]': shippingProvince.value,
          'shipping_address[zip]': shippingZip.value
        });

        /**
         * ONC-155: a cotacao da Shopify e assincrona — ela consulta a
         * transportadora e, enquanto a resposta nao chega, devolve a lista
         * VAZIA (documentado: "se as taxas nao estiverem prontas, a resposta
         * e nula"). O codigo tratava isso como erro definitivo, e era a causa
         * do "tento de novo e funciona": na segunda vez a cotacao ja esta
         * pronta. Agora esperamos a cotacao ficar pronta antes de desistir.
         */
        function consultarFrete(tentativa) {
          return fetch('/cart/shipping_rates.json?_easygift_internal=true&' + params.toString(), {
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' }
          }).then(function(response) {
            if (!response.ok) throw new Error('shipping_rates HTTP ' + response.status);
            return response.json();
          }).then(function(d) {
            var pronto = d && d.shipping_rates && d.shipping_rates.length;
            if (pronto || tentativa >= 4) return d;
            // ainda calculando: espera e pergunta de novo (1s, 2s, 3s, 4s)
            return new Promise(function(res) { setTimeout(res, 1000 * tentativa); })
              .then(function() { return consultarFrete(tentativa + 1); });
          });
        }

        // 4. Consulta as taxas de frete
        return consultarFrete(1);
      })
      .then(function(d) {
        if (d.shipping_rates && d.shipping_rates.length) {
          freteLista.innerHTML = "";

          for (var i = 0; i < d.shipping_rates.length; i++) {
            var deliveryDate = d.shipping_rates[i].delivery_date;
            var entrega = new Date(d.shipping_rates[i].delivery_date);
            var checkBeforeday = isDateBeforeToday(entrega);
            var excludeDateCheck = excludeDate(d.shipping_rates[i].name);
            var dataFormatada = entrega.getDate() + "/" + (entrega.getMonth() + 1) + "/" + entrega.getFullYear();

            var valorFrete = d.shipping_rates[i].price;

            if (valorFrete == "0.00" || valorFrete == null) {
              valorFrete = config.freeShippingText;
            } else {
              valorFrete = formatMoney(valorFrete * 100, window.MinimogSettings.money_format);
            }

            var entregaText;
            if (deliveryDate == null && excludeDateCheck || checkBeforeday && excludeDateCheck) {
              entregaText = "Estimativa de entrega indisponível";
            } else if (!excludeDateCheck) {
              entregaText = "";
            } else {
              entregaText = "(Estimativa de entrega: " + dataFormatada + ")";
            }

            var freteItem = document.createElement('div');
            freteItem.className = 'frete-item';
            freteItem.innerHTML = '<div class="frete-item__info"><p class="frete-item__name">' + d.shipping_rates[i].name + '</p>' + (entregaText ? '<span class="frete-item__delivery">' + entregaText + '</span>' : '') + '</div><div class="frete-item__price">' + valorFrete + '</div>';
            freteLista.appendChild(freteItem);
          }
        } else {
          // CEP valido, mas a transportadora nao devolveu cotacao.
          mostrarFalha('E5', 'sem opcoes de entrega para o CEP');
        }
        restoreCart();
      })
      .catch(function(err) {
        restoreCart();
        mostrarFalha(etapaAtual, err && err.message ? err.message : err);
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
